import React from "react";
import styled, { keyframes } from "styled-components";
import { RadioType } from "types/Common";
import { colors } from "constants/colors";
import RadioAndLabel from "components/atoms/RadioAndLabel";
import { StyledText } from "styles/Text";

export interface Props {
  isVisible: boolean; // 모달 노출 여부
  selectedId: number;
  list: RadioType[];
  onChange: (id: number, index?: number) => void;
  titleMessage?: string;
  closeModal?: () => void;
}

// 알럿 모달
const RadioModal: React.FC<Props> = ({
  isVisible,
  selectedId,
  list,
  onChange,
  titleMessage,
  closeModal,
}: Props) => {
  return (
    <StyledContainer $isVisible={isVisible}>
      <StyledModalBox>
        <StyledText.Headline17 as="strong">
          {titleMessage || "안내"}
        </StyledText.Headline17>
        <StyledContentWrapper>
          {list.map((item, index) => (
            <RadioAndLabel
              key={item.id}
              labelText={item.label}
              id={item.id}
              selected={item.id === selectedId}
              onValueChange={() => onChange(item.id, index)}
              padding="2px 0"
            />
          ))}
        </StyledContentWrapper>
      </StyledModalBox>
      <StyledBgDim onClick={closeModal} />
    </StyledContainer>
  );
};
export default RadioModal;

// animations
const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const StyledContainer = styled.div<{
  $isVisible: boolean;
  $paddingHorizontal?: number;
}>`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  visibility: ${({ $isVisible }) => ($isVisible ? "visible" : "hidden")};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6;
  animation: ${({ $isVisible }) => ($isVisible ? fadeIn : fadeOut)} 0.15s
    ease-out;
  padding: 0px ${({ $paddingHorizontal }) => $paddingHorizontal || 0}px;
`;

const StyledBgDim = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(0, 0, 0, 0.6);
`;

const StyledModalBox = styled.div`
  overflow: hidden;
  width: 100%; // min-width, max-width 만큼 늘림
  height: 73%;
  min-width: 280px;
  max-width: 360px;
  padding-bottom: 32px;
  background-color: ${colors.white};
  border-radius: 12px;
  box-shadow: 0px 8px 7px #00000029;
  box-sizing: border-box;
  strong {
    display: block;
    padding: 16px 20px;
    text-align: center;
  }
`;

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(100% - 57px);
  padding: 0 20px;
`;
